/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { KeyboardEvent, useContext, useEffect, useState } from 'react';
import { SearchFacetsResponse } from '../../organisms/SearchResults/store/store.type';
import {
  DefaultCurrency,
  DefaultValue,
  quickFiltersAndAmenitiesHiddenCodes,
  SearchFacetsConstants,
  SearchFacetsList,
  SearchFacetsListCodes,
} from '../../organisms/SearchResults/index.constant';
import { SearchFilterContext, SearchResultAlertContext } from '../../organisms/SearchResults/index.context';
import {
  StyledPriceContainerDiv,
  StyledHeaderContainerDiv,
  StyledPriceItemDiv,
  StyledPriceItemsContainerDiv,
  StyledPriceIncludeTaxesDiv,
} from './index.styles';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import { PriceFiltersComponentsProps } from '../../organisms/SearchResults/index.types';
import { Checkbox, RadioButton } from '@marriott/mi-ui-library-shop';
import { useCheckBreakpoint, useWindowSize } from '../../hooks';
import { formatNumberByLocale } from '../../utils';
import { BREAKPOINT_DESKTOP_1023, BREAKPOINT_TABLET } from '../../organisms/SearchResults/lib/application.constants';
import { useSessionUpdateContext } from '../../context/SessionUpdateContext';
import { usePageContext } from '../../context/PageContext/index';
import { hardCodedAllLocale } from '../../organisms/SearchResults/index.constant';
import clsx from 'clsx';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const PriceFilter: React.FC<PriceFiltersComponentsProps> = ({
  clearFilterState,
  allFilterPopUp,
  onIncludeTaxesChange,
  onItemSelect,
  jsonContents,
  onCurrencyUpdate,
  hideTaxesToggle,
  itemList,
}) => {
  const DEFAULT_PRICE_VALUE = DefaultValue;
  const clickTrackingLoc = 'Phoenix Search Results';
  const currencyLimit = 7;
  const isViewportS = useCheckBreakpoint('viewportS');

  const { jsonContent }: any = useContext(renderedData);
  const { currentLocale, sessionData } = usePageContext();
  const jsonContentData = jsonContents ?? jsonContent;
  const { searchQueryState } = useContext(SearchFilterContext);
  const { interactionsSelected, setInteractionsSelected } = useSessionUpdateContext();
  const { searchResultAlerts } = useContext(SearchResultAlertContext);
  const showFullPriceInSession = sessionData?.cacheData
    ? sessionData?.cacheData?.data?.AriesSearch?.searchCriteria?.showFullPrice
    : sessionData?.data?.AriesSearch?.searchCriteria?.showFullPrice;
  const [isTaxesSliderActive, setIsTaxesSliderActive] = useState(
    showFullPriceInSession === 'true' || searchQueryState[SearchFacetsConstants.includeTaxes]
  );
  const [selectedCurrency, setSelectedCurrency] = useState(searchQueryState.currentCurrency);
  const [currChecked, setCurrChecked] = useState<string | number>(DEFAULT_PRICE_VALUE);
  const { width } = useWindowSize();

  const handleTaxesSelection = (event: any): void => {
    event?.stopPropagation();
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      onIncludeTaxesChange(!isTaxesSliderActive);
      setIsTaxesSliderActive(!isTaxesSliderActive);
      setInteractionsSelected({ ...interactionsSelected, taxesAndFees: true });
    }
  };
  const getCurrPriceList = (): SearchFacetsResponse =>
    itemList ??
    searchQueryState?.filter?.filter((key: SearchFacetsResponse) => key.type.code === SearchFacetsListCodes.price)[0];

  const [priceList, setPriceList] = useState<SearchFacetsResponse>(getCurrPriceList());

  const [hideElement, setHideElements] = useState(
    allFilterPopUp ? currencyLimit : jsonContentData?.currencyListArray?.length
  );
  //Function to find the current currency index in input received from AEM
  const findCurrencyIndex = () => {
    const index = jsonContentData?.currencyListArray?.findIndex((item: { currencyTag: { toString: () => string } }) => {
      return (
        item?.currencyTag?.toString()?.toLocaleUpperCase() ===
        searchQueryState.currentCurrency?.toString()?.toLocaleUpperCase()
      );
    });
    return index;
  };
  const handleShowMoreLess = (event: any, currency: string): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      setHideElements(
        currency === 'less' && searchQueryState.currentCurrency === DefaultValue
          ? currencyLimit
          : searchQueryState.currentCurrency !== DefaultValue && findCurrencyIndex() < 7 && currency === 'less'
          ? currencyLimit
          : jsonContentData?.currencyListArray?.length
      );
    }
  };

  const onPriceRangeChange = (pr: number | string): void => {
    setCurrChecked(pr);
    if (pr === DEFAULT_PRICE_VALUE) {
      onItemSelect(SearchFacetsList.price, {});
    } else {
      const str = typeof pr === 'number' ? String(pr) : pr;
      onItemSelect(SearchFacetsList.price, { [str]: pr });
    }
    setInteractionsSelected({ ...interactionsSelected, price: true });
  };

  const currencySetter = (event: any, currency: string): void => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      setSelectedCurrency(currency);
      onCurrencyUpdate(currency);
      setInteractionsSelected({ ...interactionsSelected, currencyConversion: true });
    }
  };

  useEffect(() => {
    if (clearFilterState === undefined || clearFilterState === null) {
      setCurrChecked(DEFAULT_PRICE_VALUE);
      setSelectedCurrency(DefaultValue);
      onCurrencyUpdate(DefaultValue);
      setIsTaxesSliderActive(false);
    }
  }, [clearFilterState]);

  useEffect(() => {
    setCurrChecked(Object.values(searchQueryState[SearchFacetsList.price] ?? {})[0] ?? DEFAULT_PRICE_VALUE);
  }, [searchQueryState[SearchFacetsList.price]]);

  useEffect(() => {
    setPriceList(getCurrPriceList());
  }, [itemList]);

  useEffect(() => {
    if (allFilterPopUp) {
      setHideElements(
        searchQueryState.currentCurrency === DefaultValue ? currencyLimit : jsonContentData?.currencyListArray?.length
      );
    }
    onCurrencyUpdate(searchQueryState.currentCurrency);
  }, []);
  //to hide price range filter for non-US domains
  const hidePriceRange = currentLocale !== hardCodedAllLocale.en ? true : false;

  return (
    <StyledPriceContainerDiv className="t-label-alt-m">
      <div
        title={jsonContentData?.priceLabel + ' ' + jsonContentData?.filterLabel}
        role="group"
        className={clsx((hidePriceRange && !allFilterPopUp) || !isViewportS ? 'no-top-padding' : 'top-padding')}
      >
        <StyledHeaderContainerDiv className={clsx(`t-label-alt-m`, hidePriceRange && !allFilterPopUp && 'd-none')}>
          {allFilterPopUp && (
            <h4
              className={
                (width && width > BREAKPOINT_DESKTOP_1023
                  ? `t-subtitle-l`
                  : width && width > BREAKPOINT_TABLET
                  ? `t-subtitle-l`
                  : `t-subtitle-m`) + ' filter-heading'
              }
            >
              {jsonContentData?.priceLabel}
            </h4>
          )}
        </StyledHeaderContainerDiv>
        {!hidePriceRange ? (
          <div>
            <legend>
              <h6 className="t-label-xs filter-sub-heading">{jsonContentData?.selectPriceSubLabel}</h6>{' '}
            </legend>
            <StyledPriceItemsContainerDiv key={1} className="hotel-price">
              <StyledPriceItemDiv className="price-item any-price" key="any-price-key-pr">
                <RadioButton
                  radiobuttonName="price_radio"
                  checked={currChecked === DEFAULT_PRICE_VALUE}
                  customClickClass="radio-input custom_click_track"
                  radiobuttonId="any-price-key-pr"
                  onChange={(): void => onPriceRangeChange(DEFAULT_PRICE_VALUE)}
                  className="m-radio-button-m radio-container"
                  {...{
                    custom_click_track_value: `${clickTrackingLoc}| ${jsonContentData?.priceLabel} Range Selection: ${jsonContent.anyPriceLabel} |internal`,
                  }}
                  labelClassName="t-font-s col-12 item-name checkbox-radio"
                  setTabIndex={0}
                  radiobuttonLabel={jsonContentData?.anyPriceLabel}
                  // aria-labelledby="any-price-key-pr"
                ></RadioButton>
              </StyledPriceItemDiv>

              {!quickFiltersAndAmenitiesHiddenCodes.includes(searchResultAlerts?.code ?? '') &&
                priceList?.buckets?.map((price: any, idx: number) => {
                  return (
                    <StyledPriceItemDiv
                      className={`price-item ${price?.count === 0 ? 'disabled' : ''}`}
                      key={`${price?.index}pr` + idx}
                    >
                      <RadioButton
                        radiobuttonName="price_radio"
                        checked={currChecked === price.index}
                        disabled={price?.count === 0}
                        customClickClass="radio-input custom_click_track"
                        radiobuttonId={`price_radio${idx}`}
                        onChange={(): void => onPriceRangeChange(price.index)}
                        className="m-radio-button-m radio-container"
                        {...{
                          custom_click_track_value: `${clickTrackingLoc}| ${jsonContentData?.priceLabel} Range Selection: ${price?.start}-${price?.end} |internal`,
                        }}
                        labelClassName="t-font-s col-12 item-name checkbox-radio"
                        setTabIndex={price?.count === 0 ? -1 : 0}
                        radiobuttonLabel={`${price?.start}${
                          idx === priceList?.buckets?.length - 1 ? '+' : ' - ' + price?.end
                        } ${DefaultCurrency}  ${
                          price.count !== 0 ? `(${formatNumberByLocale(price?.count, currentLocale)})` : ''
                        } `}
                      ></RadioButton>
                    </StyledPriceItemDiv>
                  );
                })}
            </StyledPriceItemsContainerDiv>
          </div>
        ) : (
          ''
        )}
        {hideTaxesToggle ? (
          <div />
        ) : (
          <div>
            <StyledPriceIncludeTaxesDiv className="t-label-alt-m">
              <label
                className="include-taxes-and-fees-price-label t-font-s custom_click_track"
                tabIndex={-1}
                aria-hidden
                {...{
                  custom_click_track_value: `${clickTrackingLoc}|${jsonContentData?.filterTaxesLabel} |internal`,
                }}
              >
                {jsonContentData?.filterTaxesLabel}
              </label>
              <Checkbox
                checkboxId="include-taxes-and-fees-price"
                onChange={(): void => {
                  onIncludeTaxesChange(!isTaxesSliderActive);
                  setIsTaxesSliderActive(!isTaxesSliderActive);
                }}
                checkboxName="include-taxes-and-fees-price"
                variation="switch"
                inputClassName="custom_click_track"
                checked={isTaxesSliderActive}
                {...{
                  custom_click_track_value: `${clickTrackingLoc}| ${jsonContentData?.filterTaxesLabel} |internal`,
                  tabIndex: -1,
                }}
                children={<span className="ada-hide">{jsonContentData?.filterTaxesLabel} </span>}
                ariaLabel={jsonContent.filterTaxesLabel}
                setTabIndex={-1}
                onKeyDown={(e): void => handleTaxesSelection(e)}
              />
            </StyledPriceIncludeTaxesDiv>
          </div>
        )}
        <div>
          <legend>
            <h6 className="t-label-xs filter-sub-heading">{jsonContentData?.selectCurrencySubLabel}</h6>
          </legend>
          <StyledPriceItemsContainerDiv key={2} className="hotel-currency">
            <StyledPriceItemDiv className={`currency-item`} key={`${jsonContentData?.defaultLabel}prc`}>
              <RadioButton
                radiobuttonName="currency_radio"
                checked={selectedCurrency === DefaultValue}
                customClickClass="radio-input custom_click_track"
                radiobuttonId="currency_radio-any-currency"
                onChange={(): void => {
                  setSelectedCurrency(DefaultValue);
                  onCurrencyUpdate(DefaultValue);

                  //updateCurrencyState(currency);
                }}
                className="m-radio-button-m radio-container"
                {...{
                  custom_click_track_value: `${clickTrackingLoc}| Currency Selection: ${jsonContentData?.defaultLabel} |internal`,
                  onKeyDown: (e: KeyboardEvent): void => {
                    currencySetter(e, DefaultValue);
                    onCurrencyUpdate(DefaultValue);
                  },
                }}
                labelClassName="t-font-s col-12 item-name checkbox-radio"
                radiobuttonLabel={jsonContentData?.defaultLabel}
                setTabIndex={0}
              ></RadioButton>
            </StyledPriceItemDiv>
            {jsonContentData?.currencyListArray
              ?.filter((_currency: Record<string, string>, index: number) => index < hideElement)
              ?.map((currency: Record<string, string>, idx: number) => {
                // const priceData = priceList.buckets.filter((priceD) => priceD.code === price.code)[0];
                return (
                  <StyledPriceItemDiv className={`currency-item`} key={`${currency?.['currencyTag']}prc`}>
                    <RadioButton
                      radiobuttonName="currency_radio"
                      checked={currency?.['currencyTag'] === selectedCurrency}
                      customClickClass="radio-input custom_click_track"
                      radiobuttonId={'currency_radio' + idx}
                      onChange={(): void => {
                        setSelectedCurrency(currency?.['currencyTag']);
                        onCurrencyUpdate(currency?.['currencyTag']);
                      }}
                      className="m-radio-button-m radio-container"
                      {...{
                        custom_click_track_value: `${clickTrackingLoc}| Currency Selection: ${currency?.['currencyTag']} |internal`,
                        onKeyDown: (e: KeyboardEvent): void => {
                          currencySetter(e, currency?.['currencyTag']);
                        },
                      }}
                      labelClassName="t-font-s col-12 item-name checkbox-radio"
                      radiobuttonLabel={currency?.['currencyTag']}
                      setTabIndex={0}
                    ></RadioButton>
                  </StyledPriceItemDiv>
                );
              })}
          </StyledPriceItemsContainerDiv>
        </div>
        {allFilterPopUp ? (
          <>
            <div
              className="t-label-alt-xs show-more-less-option custom_click_track"
              role="button"
              onClick={(e): void => {
                handleShowMoreLess(e, hideElement <= currencyLimit ? 'more' : 'less');
              }}
              onKeyDown={(e): void => {
                e.stopPropagation();
                handleShowMoreLess(e, hideElement <= currencyLimit ? 'more' : 'less');
              }}
              {...{
                custom_click_track_value: `${clickTrackingLoc}| ${
                  hideElement <= currencyLimit ? jsonContentData.showLessLabel : jsonContentData.showMoreLabel
                } currency options |internal`,
              }}
              tabIndex={0}
              aria-label={`${
                hideElement <= currencyLimit ? jsonContentData.showMoreLabel : jsonContentData.showLessLabel
              }`}
            >
              {hideElement <= currencyLimit ? jsonContentData.showMoreLabel : jsonContentData.showLessLabel}
              <div className={hideElement <= currencyLimit ? 'icon-arrow-down' : 'icon-arrow-up'}></div>
            </div>
            <hr aria-hidden className="filter-separator" />
          </>
        ) : (
          ''
        )}
      </div>
    </StyledPriceContainerDiv>
  );
};
